import ApiBase from '@/services/ApiBase';
import { API_URL, getApiUrl } from '@/utils/api';
import { CartModel } from '@/models';
import { ProviderInterface } from '@/services/ProviderInterface';
import { setPaymentStatusInsideCheckout } from '@/redux/slices/checkout.slice';
import { AppDispatch } from '@/redux';

export class NoValidationService extends ApiBase implements ProviderInterface {
  static userCartUrl = getApiUrl(API_URL.USER, '/cart');

  private dispatch: AppDispatch;

  async load(): Promise<Record<string, unknown>> {
    return new Promise((resolve) => {
      resolve({ status: 'success' });
    });
  }

  async initPaymentProvider(): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(true);
    });
  }

  async createPaymentProviderForm(dispatch: AppDispatch) {
    this.dispatch = dispatch;
    return;
  }

  async processPayment() {
    this.dispatch(setPaymentStatusInsideCheckout({ status: 'pending' }));
  }

  async validatePayment(cart: CartModel) {
    return await this.api.putPromisedJSON(`${NoValidationService.userCartUrl}/${cart.storeId}/V2/validateOrder`, cart);
  }

  set _dispatch(_dispatch: AppDispatch) {
    this.dispatch = _dispatch;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set _storeId(_storeId: string) {}
}
